import SolrFacetedSearch from "./components/solr-faceted-search";
import defaultComponentPack from "./components/component-pack";
import {SolrClient} from "./api/solr-client";

export default SolrFacetedSearch;

export {
  SolrFacetedSearch,
  defaultComponentPack,
  SolrClient
};



// WEBPACK FOOTER //
// ./node_modules/solr-faceted-search-react/src/index.js